import {Injectable, Signal, signal, WritableSignal} from "@angular/core";
import {Pregnancy} from "src/app/infrastructure/moovement-api/models/asset";

@Injectable({ providedIn: 'root' })
export class PregnancyService {
  private readonly map = new Map<string, WritableSignal<Pregnancy | undefined>>();

  get(id: string | undefined): Signal<Pregnancy | undefined> | undefined {
    if (!id) return undefined;
    if (!this.map.has(id)) {
      this.map.set(id, signal(undefined));
    }
    return this.map.get(id)!.asReadonly();
  }

  update(id: string, pregnancy: Pregnancy | undefined) {
    if (!this.map.has(id)) {
      this.map.set(id, signal(pregnancy));
    } else {
      this.map.get(id)!.set(pregnancy);
    }
  }
}
